import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import Home from './pages/Home';
import Menu from './pages/Menu';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import CorporateTrial from './pages/CorporateTrial';
import Terms from './pages/Terms';
import Corporate from './pages/Corporate';
import GymChains from './pages/GymChains';
import Societies from './pages/Societies';
import ProductDetail from './pages/ProductDetail';
import PlanDetail from './pages/PlanDetail';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="app">
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/corporate-trial" element={<CorporateTrial />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/corporate" element={<Corporate />} />
        <Route path="/gym-chains" element={<GymChains />} />
        <Route path="/societies" element={<Societies />} />
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/plan/:id" element={<PlanDetail />} />
      </Routes>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default App;
